import React, { createContext, useCallback, useContext, useMemo } from "react";
import { buildOrgPath } from "@constants/Paths";
const ActiveOrganizationContext = createContext(undefined);
/**
 * Provides the organization the `/o/:orgId` segment resolved to. Mounted only by
 * `ActiveOrgLayout` once the segment has been authorized against the memberships the
 * signed-in user holds, so consumers can rely on `activeOrg` being one the user is in.
 */
export const ActiveOrganizationProvider = ({ activeOrgId, activeOrg, memberships, children, }) => {
    const contextValue = useMemo(() => ({ activeOrgId, activeOrg, memberships }), [activeOrgId, activeOrg, memberships]);
    return React.createElement(ActiveOrganizationContext.Provider, { value: contextValue }, children);
};
export const useActiveOrganization = () => {
    const context = useContext(ActiveOrganizationContext);
    if (context === undefined) {
        throw new Error("useActiveOrganization must be used within an ActiveOrganizationProvider");
    }
    return context;
};
/**
 * Non-throwing variant for surfaces shared with staff or rendered outside the org segment
 * (e.g. Restricted), which may mount without a provider.
 */
export const useOptionalActiveOrganization = () => useContext(ActiveOrganizationContext);
export const useOrgPath = () => {
    var _a;
    const activeOrgId = (_a = useOptionalActiveOrganization()) === null || _a === void 0 ? void 0 : _a.activeOrgId;
    return useCallback((path) => (activeOrgId ? buildOrgPath(activeOrgId, path) : String(path)), [activeOrgId]);
};
